var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationSharp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7164 15.8291H19.6084L21.8914 21.2801H2.10938L4.39238 15.8281H6.28438",
    fill: "white",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7164 15.8291H19.6084L21.8914 21.2801H2.10938L4.39238 15.8281H6.28438",
    stroke: "#455362",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.215 18.135C12.215 18.135 19.429 12.724 19.429 7.899C19.43 4.156 16.724 1 12.215 1C7.705 1 5 4.156 5 7.899C5 12.724 12.215 18.135 12.215 18.135Z",
    stroke: "#455362",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4658 5.5H13.9658V9H10.4658V5.5Z",
    stroke: "#455362",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationSharp);
export default __webpack_public_path__ + "static/media/location_sharp.5eb5a033eb256f20cf1572ac444d9f85.svg";
export { ForwardRef as ReactComponent };